import React from 'react'
import { SanityCareers } from '../../../../../types/generated/graphql-types'
import { sanityCareersToCareersProps } from '../../../../mapping/CareerMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { Careers } from '../../../blocks/Careers'
import { Section } from '../../../Section'

export interface CareersSerializerProps extends SanityCareers, BlockWithId {
  pageHasStickyMenu?: boolean
}

export const CareersSerializer = ({
  id,
  pageHasStickyMenu,
  ...props
}: CareersSerializerProps) => (
  <Section id={id}>
    <Careers
      {...sanityCareersToCareersProps(props, 'portrait')}
      pageHasStickyMenu={pageHasStickyMenu}
    />
  </Section>
)
